import { Navigate, Route, Routes } from "react-router-dom";
import PreviewChrome from "@/pages/designPreview/PreviewChrome";
import PreviewIndex from "@/pages/designPreview/PreviewIndex";
import CapabilitiesPreview from "@/pages/designPreview/CapabilitiesPreview";
import AuthorityPreview from "@/pages/designPreview/AuthorityPreview";
import GuidesPreview from "@/pages/designPreview/GuidesPreview";
import GuideDetailPreview from "@/pages/designPreview/GuideDetailPreview";

export default function PreviewRoutes() {
  return (
    <Routes>
      <Route element={<PreviewChrome />}>
        <Route index element={<PreviewIndex />} />
        <Route path="capabilities" element={<CapabilitiesPreview />} />
        <Route path="capabilities-a" element={<Navigate to="/design-preview/capabilities" replace />} />
        <Route path="capabilities-b" element={<Navigate to="/design-preview/capabilities" replace />} />
        <Route path="authority" element={<AuthorityPreview />} />
        <Route path="guides" element={<GuidesPreview />} />
        <Route path="guides-a" element={<Navigate to="/design-preview/guides" replace />} />
        <Route path="guides-b" element={<Navigate to="/design-preview/guides" replace />} />
        <Route path="guide-detail" element={<GuideDetailPreview />} />
        <Route path="guide-detail/:slug" element={<GuideDetailPreview />} />
      </Route>
    </Routes>
  );
}
